'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Flashlight';

var EntypoFlashlight = function EntypoFlashlight(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M17.115,2.884c-1.676-1.676-3.779-2.288-4.449-1.618L9.97,3.962C9.561,4.372,9.204,5.741,9.368,7.126l-8.161,8.161c-0.484,0.484-0.092,1.66,0.876,2.629c0.968,0.969,2.146,1.359,2.629,0.877l8.161-8.162c1.386,0.164,2.755-0.193,3.164-0.601l2.696-2.697C19.403,6.663,18.791,4.559,17.115,2.884z M8.141,11.039C7.768,10.667,7.89,9.943,8.41,9.422c0.521-0.521,1.246-0.643,1.618-0.27c0.372,0.371,0.251,1.097-0.27,1.617C9.237,11.291,8.513,11.412,8.141,11.039z M14.891,5.108c-1.298-1.297-1.623-3.01-1.508-3.125c0.115-0.116,1.76,0.277,3.059,1.575c1.298,1.298,1.688,2.946,1.575,3.059C17.905,6.729,16.188,6.407,14.891,5.108z' })
    );
};

exports.default = EntypoFlashlight;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo-icons/lib/entypo/Flashlight.js
// module id = 583
// module chunks = 168707334958949